import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const Wrapper = styled.div`
  width: 100%;
`;

export const PageTitle = styled.div`
  margin-bottom: 10px;
  font-size: ${calcRem(14)};
  color: ${({ theme }) => `${theme.COLORS.WHITE}60`};
`;

export const FilterBar = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  margin-bottom: 10px;

  label {
    font-size: ${calcRem(14)};
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  ${mediaQuery.isMobile} {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Select = styled.select`
  min-width: 180px;
  height: 34px;
  border: 1px solid ${({ theme }) => `${theme.COLORS.WHITE}18`};
  border-radius: 4px;
  background: ${({ theme }) => theme.COLORS.WHITE};
  color: #1d2333;
  padding: 0 10px;
  font-size: ${calcRem(13)};
`;

export const TableSkin = styled.div`
  .table-wrapper,
  .ant-table-wrapper,
  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table,
  .ant-table-container,
  .ant-table-content {
    height: auto !important;
    min-height: 0 !important;
  }

  .ant-table {
    background: transparent !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-thead > tr > td {
    background: ${({ theme }) => theme.COLORS.PRIMARY3} !important;
  }

  .ant-table-tbody > tr > td,
  .ant-table-tbody > tr > .ant-table-cell {
    background: transparent !important;
  }
`;

export const EventText = styled.span`
  color: ${({ theme }) => theme.COLORS.WHITE};
`;

export const ChangeText = styled.span<{ $tone: "positive" | "negative" }>`
  color: ${({ $tone, theme }) =>
    $tone === "positive" ? theme.COLORS.GREEN : "#ff5a36"};
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  .account-info-label-accountName {
    color: ${({ theme }) => theme.COLORS.WHITE} !important;
    font-weight: normal;
  }
`;
